import { useContext, type ReactNode } from 'react'
import { useAnalytics } from '@/analytics/hooks/useAnalytics'
import { TableEntrySource } from '@/analytics/enums/table.enums'
import { trackTableOpened } from '@/analytics/utils/table-analytics'
import { TableTitlesContext } from './table-titles-context'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { Table } from '@/assets/icons'
import { Link } from '@/components/link/Link'
import { TableNavigationContext } from './TableNavigationContext'

export default function TableInlineLink({ href, matterId, tableId, children }: { href: string; matterId: string; tableId: string; children: ReactNode }) {
  const { enabled, loading } = useRuntimeFeatureFlag(RuntimeFeatureFlag.TABLES)
  const navigation = useContext(TableNavigationContext)
  const titles = useContext(TableTitlesContext)
  const { trackEvent } = useAnalytics()
  if (loading || !enabled) return <span>{children}</span>
  return (
    <Link
      href={href}
      onClick={(event) => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
        if (navigation?.matterId !== matterId) return
        event.preventDefault()
        const record = titles?.tablesByMatter[matterId]?.find((item) => item.id === tableId)
        trackTableOpened(trackEvent, {
          tableId,
          matterId,
          tableEntrySource: TableEntrySource.Chat,
          ...(record ? { documentAnalysis: record.document_analysis } : {}),
        })
        navigation.openTable(tableId)
      }}
    >
      <Table aria-hidden="true" className="mr-1 inline-block h-4 w-4 align-text-bottom" />
      {children}
    </Link>
  )
}
